/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'
import styled from 'styled-components'
import { v4 } from 'uuid'

import { Button, Icon, Box, TextBody } from '@ally/metronome-ui'
import { deprecated } from '@ally/metronome-icons'
import { Private } from '@ally/private'
import { OTPMethod } from '@ally/transmitigator'

import { formatSMS } from '../../../Utils'

interface RemoveButtonProps {
  className?: string
  removeOption: (indexToRemove: number) => void
  index: number
}

const RemoveButton: React.FC<RemoveButtonProps> = ({
  className,
  removeOption,
  index,
}) => {
  return (
    <Box className={className}>
      <Button
        variant="link"
        text="Remove"
        type="button"
        onClick={(): void => removeOption(index)}
      />
    </Box>
  )
}

const OptionWrapper = styled.div`
  display: flex;
  font-size: 14px;
  width: 100%;
  padding: 10.5px;
  margin-bottom: 12px;
  justify-content: flex-start;

  :last-child {
    margin-bottom: 0px;
  }
`

const StyledRemoveButton = styled(RemoveButton)`
  ${({ theme: { colors } }): string => `
    border-left: 1px solid ${colors['slate-3']}
    padding-left: 14px;
  `}
`

interface OptionProps {
  index: number
  option: OTPMethod
  removeOption: (indexToRemove: number) => void
}

const Option: React.FC<OptionProps> = ({
  index,
  option: { value },
  removeOption,
}) => {
  return (
    <OptionWrapper>
      <Box display="flex" alignItems="center" mr="xl">
        <Icon icon={deprecated.muiCheckMark} fill="success" size="md" />
        &nbsp;
        <Private as="span">
          <TextBody size="sm" tag="span">
            {formatSMS(value)}
          </TextBody>
        </Private>
      </Box>
      <Box>
        <StyledRemoveButton removeOption={removeOption} index={index} />
      </Box>
    </OptionWrapper>
  )
}

interface DeliveryOptionsProps {
  options: OTPMethod[]
  removeOption: (indexToRemove: number) => void
}

export const DeliveryOptions: React.FC<DeliveryOptionsProps> = ({
  options,
  removeOption,
}) => {
  return (
    <>
      {options.map(
        (option, index): React.ReactNode => {
          return (
            <Option
              key={v4()}
              option={option}
              removeOption={removeOption}
              index={index}
            />
          )
        },
      )}
    </>
  )
}
